/**
 * SmartThings' webview ignores target="_blank" and window.open, but a
 * same-window navigation works (the Samsung login uses it). Open drtail.us
 * pages in place; the SmartThings back button returns here.
 */
export const openInPlace = (url: string) => {
  window.location.href = url
}

/** drtail.us for production builds, dev.drtail.us for acceptance (dev-1 API) */
export const WEB_BASE_URL = /dev-\d\.api|dev\.api/.test(String(import.meta.env.VITE_HOST))
  ? 'https://dev.drtail.us'
  : 'https://www.drtail.us'
